import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import { UpdateAddressRepository } from '../../../domain/repository/update-address-repository';

@Injectable()
export default class UpdateAddressDummyRepository implements UpdateAddressRepository {
  update() {
    return Promise.resolve();
  }
}
